import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <XCircle className="h-20 w-20 text-orange-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Ödeme İptal Edildi</h1>
        <p className="text-lg text-gray-700 mb-6">
          Ödeme işleminiz iptal edildi. Herhangi bir ücret yansıtılmadı.
        </p>
        <p className="text-gray-600 mb-8">
          Dilediğiniz zaman tekrar ödeme yapabilirsiniz.
        </p>
        <div className="flex space-x-4">
          <button
            onClick={() => navigate('/pricing')}
            className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-700 transition-all shadow-lg"
          >
            Planları Gör
          </button>
          <button
            onClick={() => navigate('/student/dashboard')}
            className="flex-1 border-2 border-gray-300 text-gray-700 px-6 py-3 rounded-xl font-semibold hover:bg-gray-50 transition-all"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;